/* BALDSPLASH — Shipping Protection add-on (cart toggle) + "never alone" guard.
 * - Added automatically (switch ON) together with the shopper's product; switching it OFF removes it and it is
 *   not re-added for the rest of the browser session.
 * - Always quantity 1; its cart line is hidden (only the toggle represents it).
 * - If the cart ends up holding only the protection, the whole cart is cleared and the shopper is sent to the
 *   product page. Checkout buttons, express checkout buttons and /checkout links are gated the same way.
 */
(function () {
  'use strict';
  var CFG = window.BS_PROTECTION || {};
  var HANDLE = CFG.handle || 'shipping-protection';
  var PRODUCT_URL = CFG.productUrl || '/products/baldsplash-bald-head-swim-cap';
  var VARIANT_ID = Number(CFG.variantId) || 0;
  var OPT_OUT_KEY = 'bsProtectionOff';
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var MUTATING = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var ADD = /\/cart\/add(\.js)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var state = { real: Number(CFG.realItems) || 0, prot: Number(CFG.protQty) || 0 };

  function url(path) { return root + path; }
  function optedOut() { try { return window.sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; } }
  function setOptOut(off) { try { if (off) window.sessionStorage.setItem(OPT_OUT_KEY, '1'); else window.sessionStorage.removeItem(OPT_OUT_KEY); } catch (e) {} }
  function onProductPage() { return window.location.pathname.replace(/\/$/, '') === url(PRODUCT_URL).replace(/\/$/, ''); }

  function bsFetch(path, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'X-BS-Protection': '1' }, opts.headers || {});
    return nativeFetch(url(path), opts);
  }
  function postJSON(path, body) {
    return bsFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function isProt(it) { return it.handle === HANDLE || Number(it.variant_id) === VARIANT_ID; }
  function split(cart) {
    var s = { real: 0, prot: 0, lines: [] };
    (cart.items || []).forEach(function (it) {
      if (isProt(it)) { s.prot += it.quantity; s.lines.push(it); } else { s.real += it.quantity; }
    });
    return s;
  }
  function getCart() {
    return bsFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { var s = split(cart); state.real = s.real; state.prot = s.prot; return cart; });
  }
  function onlyProtection() { return state.real === 0 && state.prot > 0; }

  /* ---------- Re-render cart UI (drawer, bubble, /cart) without reloading ---------- */
  function sectionHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  function refresh() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    return bsFetch('/cart?sections=' + ids.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && s['cart-drawer']) {
          var nd = sectionHTML(s['cart-drawer'], 'cart-drawer');
          var cur = drawer.querySelector('.drawer__inner');
          var nxt = nd && nd.querySelector('.drawer__inner');
          if (cur && nxt) cur.innerHTML = nxt.innerHTML;
          if (nd) drawer.classList.toggle('is-empty', nd.classList.contains('is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var nb = sectionHTML(s['cart-icon-bubble'], '.shopify-section');
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
        if (items && s[items.dataset.id]) {
          var ni = sectionHTML(s[items.dataset.id], 'cart-items');
          var ci = document.querySelector('cart-items');
          if (ni && ci) {
            ci.classList.toggle('is-empty', ni.classList.contains('is-empty'));
            var a = ci.querySelector('#main-cart-items .js-contents'), b = ni.querySelector('#main-cart-items .js-contents');
            if (a && b) a.innerHTML = b.innerHTML;
          }
        }
        if (footer && s[footer.dataset.id]) {
          var nf = sectionHTML(s[footer.dataset.id], '#main-cart-footer');
          if (nf) { footer.innerHTML = nf.innerHTML; footer.classList.toggle('is-empty', nf.classList.contains('is-empty')); }
        }
      })
      .catch(function () {});
  }

  /* ---------- Only the protection left: empty the cart and go to the product page ---------- */
  var emptying = null;
  function emptyAndLeave() {
    if (emptying) return emptying;
    emptying = bsFetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .catch(function () {})
      .then(function () {
        state.real = 0; state.prot = 0;
        if (onProductPage()) return refresh();
        window.location.href = url(PRODUCT_URL);
        return new Promise(function () {});
      })
      .then(function () { emptying = null; });
    return emptying;
  }

  /* ---------- Guard: runs on load, on every cart change and when the drawer opens ---------- */
  var guarding = null;
  function guard() {
    if (guarding) return guarding;
    guarding = getCart().then(function (cart) {
      var s = split(cart);
      if (s.real === 0 && s.prot > 0) return emptyAndLeave().then(function () { return false; });
      var ops = [];
      if (s.lines.length > 1 || (s.lines[0] && s.lines[0].quantity !== 1)) {
        s.lines.forEach(function (l, i) { ops.push(function () { return postJSON('/cart/change.js', { id: l.key, quantity: i === 0 ? 1 : 0 }); }); });
      }
      var card = document.querySelector('[data-bs-protect-card]');
      var sw = card && card.querySelector('input[data-bs-protection]');
      var stale = (!!card !== s.real > 0) || (!!sw && sw.checked !== s.prot > 0);
      if (!ops.length) return stale;
      return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve()).then(function () { state.prot = 1; return true; });
    })
      .then(function (changed) { return changed ? refresh() : null; })
      .catch(function () {})
      .then(function () { guarding = null; });
    return guarding;
  }
  var guardTimer;
  function scheduleGuard(delay) { clearTimeout(guardTimer); guardTimer = setTimeout(guard, delay == null ? 150 : delay); }

  /* ---------- Default ON: add the protection together with the shopper's product ---------- */
  function bodyInfo(init) {
    var info = { variantIds: [], sections: null, sectionsUrl: null };
    var body = init && init.body;
    if (!body) return info;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.getAll('id').concat(body.getAll('items[][id]')).forEach(function (v) { info.variantIds.push(Number(v)); });
        info.sections = body.get('sections'); info.sectionsUrl = body.get('sections_url');
      } else if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          if (j.id) info.variantIds.push(Number(j.id));
          (j.items || []).forEach(function (it) { info.variantIds.push(Number(it.id)); });
          info.sections = j.sections || null; info.sectionsUrl = j.sections_url || null;
        } else {
          var p = new URLSearchParams(body);
          p.getAll('id').concat(p.getAll('items[][id]')).forEach(function (v) { info.variantIds.push(Number(v)); });
          info.sections = p.get('sections'); info.sectionsUrl = p.get('sections_url');
        }
      }
    } catch (e) {}
    if (Array.isArray(info.sections)) info.sections = info.sections.join(',');
    return info;
  }
  function addWithProtection(input, init, info) {
    return nativeFetch(input, init).then(function (resp) {
      if (!resp.ok || !VARIANT_ID || optedOut() || state.prot > 0) { scheduleGuard(); return resp; }
      var body = { items: [{ id: VARIANT_ID, quantity: 1 }] };
      if (info.sections) body.sections = info.sections;
      if (info.sectionsUrl) body.sections_url = info.sectionsUrl;
      return bsFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (added) {
          if (!added) { scheduleGuard(); return resp; }
          state.prot = 1; state.real = Math.max(state.real, 1);
          if (!info.sections || !added.sections) { scheduleGuard(); setTimeout(refresh, 120); return resp; }
          // Hand the theme the sections rendered after both adds, so the drawer opens already showing the switch ON.
          return resp.clone().json().then(function (first) {
            first.sections = added.sections;
            scheduleGuard(600);
            return new Response(JSON.stringify(first), { status: resp.status, statusText: resp.statusText, headers: { 'Content-Type': 'application/json' } });
          });
        })
        .catch(function () { scheduleGuard(); return resp; });
    });
  }

  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var h = init && init.headers;
    var mine = h && (h['X-BS-Protection'] || (typeof h.get === 'function' && h.get('X-BS-Protection')));
    if (mine || !MUTATING.test(u)) return nativeFetch(input, init);
    if (ADD.test(u)) {
      var info = bodyInfo(init);
      if (info.variantIds.length && info.variantIds.indexOf(VARIANT_ID) === -1) return addWithProtection(input, init, info);
    }
    var p = nativeFetch(input, init);
    p.then(function () { scheduleGuard(); }, function () { scheduleGuard(); });
    return p;
  };

  /* ---------- Toggle ---------- */
  var desired = null, running = false;
  function variantId() {
    var el = document.querySelector('input[data-bs-protection]');
    return Number((el && el.getAttribute('data-variant-id')) || VARIANT_ID);
  }
  function setCards(checked, busy) {
    document.querySelectorAll('input[data-bs-protection]').forEach(function (i) { i.checked = checked; });
    document.querySelectorAll('[data-bs-protect-card]').forEach(function (c) { c.classList.toggle('is-busy', !!busy); });
  }
  function reconcile() {
    if (running) return;
    running = true;
    setCards(desired, true);
    var tries = 0;
    function step() {
      tries++;
      var want = desired;
      return getCart().then(function (cart) {
        var s = split(cart);
        if (s.real === 0) return emptyAndLeave().then(function () { return true; });
        if (want && !s.lines.length) return postJSON('/cart/add.js', { items: [{ id: variantId(), quantity: 1 }] }).then(function () { return false; });
        if (want && (s.lines.length > 1 || s.lines[0].quantity !== 1)) {
          return s.lines.reduce(function (p, l, i) { return p.then(function () { return postJSON('/cart/change.js', { id: l.key, quantity: i === 0 ? 1 : 0 }); }); }, Promise.resolve()).then(function () { return false; });
        }
        if (!want && s.lines.length) {
          return s.lines.reduce(function (p, l) { return p.then(function () { return postJSON('/cart/change.js', { id: l.key, quantity: 0 }); }); }, Promise.resolve()).then(function () { return false; });
        }
        return want === desired;
      }).then(function (done) { if (!done && tries < 8) return step(); });
    }
    step().catch(function () {}).then(refresh).then(function () {
      running = false;
      setCards(desired, false);
      getCart().then(function (cart) {
        var s = split(cart);
        if (s.real > 0 && (s.prot > 0) !== desired) reconcile();
      }).catch(function () {});
    });
  }
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('input[data-bs-protection]');
    if (!input) return;
    desired = input.checked;
    setOptOut(!desired);
    reconcile();
  });

  /* ---------- Checkout gate (Check out buttons, express checkout, /checkout links) ---------- */
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, a[href$="/checkout"], a[href*="/checkout?"], a[href*="/checkouts/"]';
  var EXPRESS_SEL = '.additional-checkout-buttons, .cart__dynamic-checkout-buttons, shopify-accelerated-checkout-cart, [data-shopify="dynamic-checkout-cart"]';
  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); }
  function goCheckout(e) {
    stop(e);
    getCart().then(function (cart) {
      var s = split(cart);
      if (s.real === 0) {
        if (s.prot > 0) return emptyAndLeave();
        window.location.href = url(PRODUCT_URL);
        return null;
      }
      var fixes = [];
      if (s.lines.length > 1 || (s.lines[0] && s.lines[0].quantity !== 1)) {
        s.lines.forEach(function (l, i) { fixes.push(function () { return postJSON('/cart/change.js', { id: l.key, quantity: i === 0 ? 1 : 0 }); }); });
      }
      return fixes.reduce(function (p, f) { return p.then(f); }, Promise.resolve())
        .then(function () { window.location.href = url('/checkout'); });
    }).catch(function () { window.location.href = url('/cart'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(EXPRESS_SEL)) {
      // Express buttons open checkout themselves; they are only let through when the cart holds a real product.
      if (state.real === 0) { stop(e); if (state.prot > 0) emptyAndLeave(); else window.location.href = url(PRODUCT_URL); }
      return;
    }
    var btn = t.closest(CHECKOUT_SEL);
    if (btn && !btn.disabled) goCheckout(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') goCheckout(e);
  }, true);

  /* ---------- Empty drawer: X / overlay go to the product page ---------- */
  document.addEventListener('click', function (e) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('is-empty')) return;
    var hit = e.target.closest && e.target.closest('cart-drawer .drawer__close, #CartDrawer-Overlay');
    if (!hit || onProductPage()) return;
    stop(e);
    window.location.href = url(PRODUCT_URL);
  }, true);

  /* ---------- Checks on load, on back/forward and when the drawer opens ---------- */
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    var wasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      if (open && !wasOpen) scheduleGuard(0);
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (onlyProtection()) emptyAndLeave();
  function init() { watchDrawer(); scheduleGuard(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleGuard(0); });
})();
